import { render, staticRenderFns } from "./DkWizardLeadFormSubmission.vue?vue&type=template&id=68c4d5ee&"
import script from "./DkWizardLeadFormSubmission.vue?vue&type=script&lang=js&"
export * from "./DkWizardLeadFormSubmission.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports